import { Layer } from "dnv-lib";

export interface WMRPState {
    materials: any;
    module: WMRPModule[];
    templates: WmrpAnalysisParamSet[]
    currentConditions: WmrpAnalysisParam[];
    savedTemplate: WmrpSaveObject;
    showExpandParametersBtn: boolean;
    recentAnalysisRunData: WmrpAnalysisRun[];
    selectedRun: WmrpAnalysisRun;
    replacementSchedules: WmrpReplacementSched[];
    selectedReplacementSchedule: WmrpReplacementSched;
    wmrpState: WmrpState;
    wmrpResults: WmrpResults[];
    layers: Layer[];
    exclusionLayerMains: any[];
}

export interface WMRPModule {
    id: number;
    title: string;
    description: string;
    breakDescription: string;
    breakType: ModuleBreakType;
    category: ModuleCategory;
    fmeEnable: string;
    fmeConditions: string;
    order: number;
}

export interface lookupDictionary {
    disabled: boolean;
    name: string;
    code: string;
}

export enum ModuleBreakType {
    string,
    number
}

export enum ModuleCategory {
    probability,
    consequence
}

export interface WmrpCondition {
    breakValue: string | string[] | number,
    analysisValue: number,
    alias: string,
    isLast: boolean
}

export interface WmrpAnalysisParamSet {
    id: number;
    name: string;
    isTemplate: boolean;
    isDefault: boolean;
}

export interface WmrpAnalysisParam {
    id?: number;
    changed?: boolean;
    wmrpAnalysisParamSet_Id?: number;
    // wmrpIsTemplate: boolean;
    // wmrpTemplateName: string;
    wmrpModule_Id: number;
    enabled: boolean;
    conditions: string | WmrpCondition[];
}
// fyi
// keeping value here as a backup for [WmrpAnalysisParams] Id 2
// was
// [{"breakValue":["AC","CONCRETE"],"analysisValue":1,"alias":"","isLast":false},{"breakValue":["GALVANIZED","WOODSTAVE","PVC","COPPER"],"analysisValue":2,"alias":"","isLast":false},{"breakValue":["CI","DI","STEEL"],"analysisValue":33,"alias":"","isLast":false}]
// updated to
// [{"breakValue":"AC,CONCRETE","analysisValue":1,"alias":"","isLast":false},{"breakValue":"GALVANIZED,WOODSTAVE,PVC,COPPER","analysisValue":2,"alias":"","isLast":false},{"breakValue":"CI,DI,STEEL","analysisValue":33,"alias":"","isLast":false}]

export interface WmrpSaveObject {
    wmrpIsTemplate: boolean;
    wmrpTemplateName: string;
    wmrpAnalysisParams: WmrpAnalysisParam[];
}

export interface WmrpAnalysisRun {
    id?: number,
    wmrpAnalysisParamSet_Id: number;
    fmeJobId: string;
    status: string;
    fmeReference: string;
    schedulesCount: number;
}

export interface WmrpReplacementSchedParam {
    fmeReference: string;
    analysisValueEnabled: boolean;
    addressingEnabled: boolean;
    endOfLifeEnabled: boolean;
    numBreaksEnabled: boolean;
    exclusionLayerEnabled: boolean;
    // scheduleTask?
    replacementMetresPerYear: number;
    startYear: number;
    endYear: number;
}

export interface WmrpReplacementSched {
    id: number;
    fmeJobId: string;
    fmeReference_Job: string;
    analysisValueEnabled: boolean;
    addressingEnabled: boolean;
    endOfLifeEnabled: boolean;
    numBreaksEnabled: boolean;
    exclusionLayerEnabled: boolean;
    // scheduleTask?
    replacementMetresPerYear: number;
    startYear: string;
    endYear: string;
    createdAt: Date;
    username: string;
    fmeReference_Schedule: string;
    status: string;
    title: string;
}

export const initialWMRPState: WMRPState = {
    materials: [],
    module: [],
    templates: [],
    currentConditions: [],
    savedTemplate: {} as WmrpSaveObject,
    showExpandParametersBtn: false,
    recentAnalysisRunData: [],
    selectedRun: {} as WmrpAnalysisRun,
    replacementSchedules: [],
    selectedReplacementSchedule: null,
    wmrpState: {
        hazardBoundaryLow: 200,
        hazardBoundaryHigh: 400
    },
    wmrpResults: [],
    layers: [],
    exclusionLayerMains: []
};

export class WmrpResults {
    watermain_id: string;
    analysis_value: number;
}

export interface WmrpState {
    hazardBoundaryLow: number;
    hazardBoundaryHigh: number;
}

export interface WmrpSaveTitleObject {
    fmeJobId: string;
    title: string;
}

// TODO there are 3 versions of the parameters right now, ie:
// the component wants moduleId

// the server is sending WmrpAnalysisParam.wmrpModule_Id
// and the client is sending back WmrpParams.wmrpModuleId
// if defaultConditions could be given a specific type, then we can translate back and forth if necessary
// with WmrpAnalysisParam I was going for the format sent by the backent, but no strong opinion on any
// as long as we pick one?
